/*****************************************************************************/
/*  File Name: systems.js                                                    */
/*  Date:      June 21, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This will handle the selection of the systems for the left 
/*             hand bar
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import styles from './styles/roi.module.scss';
import { useROIContext } from '../../context/roiContext';
import { useSystemContext } from '../../context/systemContext';
import * as MODES from '../../constants/modes';
import SystemBlock from './elements/systemBlock';

function SystemSideBar({ t }) {
  //Load all of the default component varaibles
  const { roiMode } = useROIContext();
  const { systemsLoading, systems } = useSystemContext();

  //console.log('this is my system from the bar systems----> ', systems);

  //////////////////////////////////////////////////////////////////////////
  //
  // Get the logo files from firebase
  //
  //////////////////////////////////////////////////////////////////////////

  //console.log('this is my systems ----< ', systems);



  return (
    <Grid item xs={12} container>
      <Grid item xs={12} className={styles.sectionTitle}>
        Select a System
      </Grid>
      <Grid item xs={12} className={styles.systemTable}>
      {!systemsLoading
        ? systems.length > 0
          ? systems.map((system, i) => {
              //console.log("system.upgradeDevice ->", system.upgradeDevice);

              return roiMode === MODES.upgrade ? (
                system.upgradeDevice ? (
                  <SystemBlock system={system} key={system.id} />
                ) : null
              ) : (
                // in normal mode → only show systems WITHOUT upgradeDevice
                !system.upgradeDevice ? (
                  <SystemBlock system={system} key={system.id} />
                ) : null
              );
            })
          : "Systems Failed to load"
        : "Systems Loading"}
    </Grid>
    </Grid>
  );
}

export default withTranslation()(SystemSideBar);
